export default "__VITE_ASSET__DQM915aR__"